import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-template-columns: 16px 1fr auto;
  grid-template-areas: 'image text date';
  grid-column-gap: 0.5rem;
`;
